import React from "react";

import { Button, Divider } from "@mui/material";

import SettingsTitle from "@app/analytics/account/components/SettingsTitle";
import WorkspaceSettingsAccordion from "@app/analytics/account/WorkspaceSettings/components/WorkspaceSettingsAccordion";

import Alert from "@rui/Alert";
import { Row, Column } from "@rui/Stack";

const MemberWorkspaceActions = ({
  isTeamManager,
  onClickMigrateMeetings,
  onClickLeaveWorkspace,
}: {
  isTeamManager: boolean;
  onClickMigrateMeetings: () => void;
  onClickLeaveWorkspace: () => void;
}) => {
  return (
    <WorkspaceSettingsAccordion
      title="Workspace Actions"
      subtitle="Leave Workspace, Migrate Meetings"
      defaultExpanded
    >
      <Column spacing={2}>
        <Row variant="left" spacing={2}>
          <SettingsTitle
            title="Migrate Meetings"
            subtitle="Move past meetings measured with Read to this Workspace for more robust trends and insights."
            sx={{ width: "100%" }}
          />
          <Button
            variant="text"
            sx={{ width: "200px", height: "44px" }}
            onClick={onClickMigrateMeetings}
          >
            Migrate Meetings
          </Button>
        </Row>
        <Divider />
        <Column variant="left" spacing={1}>
          <Row variant="apart" spacing={2} width="100%">
            <SettingsTitle
              title="Leave Workspace"
              subtitle="This action is permanent and cannot be undone. You will lose access to the Workspace and all associated data."
              sx={{ width: "100%" }}
            />
            <Button
              variant="text"
              color="error"
              sx={{ width: "200px", height: "44px" }}
              onClick={onClickLeaveWorkspace}
              disabled={isTeamManager}
            >
              Leave Workspace
            </Button>
          </Row>
          {isTeamManager && (
            <Alert
              embedded
              severity="warning"
              sx={{ width: "auto" }}
              fullWidth={false}
            >
              You are a Manager of at least one team. You must first transfer
              your Manager role to a team member or delete the team before you
              can leave this Workspace.
            </Alert>
          )}
        </Column>
      </Column>
    </WorkspaceSettingsAccordion>
  );
};

export default MemberWorkspaceActions;
